module.exports = __webpack_public_path__ + "static/media/product_04.9d4737e8.jpg";